import { useState, useEffect } from "react";
import "./App.css";
import { GERBERAS, ROSAS, LILIES, GIRASOLES, COMPLEMENTOS, CATEGORIES } from "./catalogData";

/* ==============================================================
   Alma Mía · Arte Floral
   Single-page luxury floral boutique site (Spanish)
   Location: Tren Maya Estación Escárcega, Campeche, México
   ============================================================== */

const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_flores-escarcega/artifacts/7mqyum4z_483838887_1192304492903421_467254603771541663_n.jpg";

const WHATSAPP_NUMBER = "529821156234"; // +52 982 115 6234
const WA_GENERAL_MESSAGE =
    "Hola Alma Mía 🌸 Quisiera hacer un pedido, ¿me puedes ayudar?";

const buildWhatsappLink = (message) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

const buildProductWaLink = (productName) =>
    buildWhatsappLink(
        `Hola Alma Mía 🌸 Me interesa el siguiente diseño: ${productName}. ¿Me puedes dar más información y disponibilidad?`
    );

/* ---------- Floral SVG motifs (used as placeholder art) ---------- */
const Bouquet = ({ variant = 1 }) => {
    if (variant === 1)
        return (
            <svg viewBox="0 0 200 240" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" fill="none">
                    <circle cx="100" cy="80" r="18" />
                    <circle cx="75" cy="95" r="14" />
                    <circle cx="125" cy="95" r="14" />
                    <circle cx="85" cy="65" r="12" />
                    <circle cx="115" cy="65" r="12" />
                    <circle cx="100" cy="55" r="10" />
                    <path d="M100 110 C 95 150, 105 180, 100 220" />
                    <path d="M100 130 C 80 140, 70 160, 70 185" />
                    <path d="M100 130 C 120 140, 130 160, 130 185" />
                    <path d="M60 220 L 140 220" />
                    <path d="M100 80 L 100 58" strokeOpacity="0.4" />
                </g>
            </svg>
        );
    if (variant === 2)
        return (
            <svg viewBox="0 0 200 240" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" fill="none">
                    <path d="M100 40 C 70 55, 65 85, 90 95 C 75 105, 75 130, 100 130 C 125 130, 125 105, 110 95 C 135 85, 130 55, 100 40 Z" />
                    <circle cx="100" cy="85" r="8" />
                    <path d="M60 115 C 45 125, 45 145, 65 155" />
                    <path d="M140 115 C 155 125, 155 145, 135 155" />
                    <path d="M100 130 L 100 210" />
                    <path d="M100 160 C 85 170, 80 185, 85 205" />
                    <path d="M100 160 C 115 170, 120 185, 115 205" />
                </g>
            </svg>
        );
    if (variant === 3)
        return (
            <svg viewBox="0 0 200 240" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" fill="none">
                    <rect x="50" y="120" width="100" height="80" rx="4" />
                    <path d="M50 140 L 150 140" strokeOpacity="0.4" />
                    <circle cx="85" cy="100" r="16" />
                    <circle cx="115" cy="100" r="16" />
                    <circle cx="100" cy="78" r="12" />
                    <circle cx="70" cy="85" r="10" />
                    <circle cx="130" cy="85" r="10" />
                    <path d="M100 120 L 100 140" />
                    <path d="M80 120 L 80 140" />
                    <path d="M120 120 L 120 140" />
                </g>
            </svg>
        );
    if (variant === 4)
        return (
            <svg viewBox="0 0 200 240" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" fill="none">
                    <path d="M50 130 Q 100 100, 150 130 L 140 200 Q 100 215, 60 200 Z" />
                    <path d="M50 130 Q 100 115, 150 130" strokeOpacity="0.4" />
                    <path d="M60 130 Q 100 90, 140 130" />
                    <circle cx="85" cy="100" r="14" />
                    <circle cx="115" cy="100" r="14" />
                    <circle cx="100" cy="80" r="10" />
                    <circle cx="72" cy="115" r="8" />
                    <circle cx="128" cy="115" r="8" />
                </g>
            </svg>
        );
    if (variant === 5)
        return (
            <svg viewBox="0 0 200 240" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" fill="none">
                    <circle cx="70" cy="85" r="6" />
                    <circle cx="130" cy="75" r="7" />
                    <circle cx="100" cy="55" r="5" />
                    <circle cx="88" cy="100" r="8" />
                    <circle cx="115" cy="95" r="6" />
                    <path d="M70 85 C 85 130, 90 170, 85 215" />
                    <path d="M130 75 C 125 120, 120 170, 125 215" />
                    <path d="M100 55 C 100 100, 105 160, 105 215" />
                    <path d="M88 100 C 95 140, 92 180, 95 215" />
                    <path d="M115 95 C 110 135, 115 180, 110 215" />
                    <path d="M60 140 L 80 155" strokeOpacity="0.5" />
                    <path d="M140 140 L 120 155" strokeOpacity="0.5" />
                    <path d="M60 215 L 140 215" />
                </g>
            </svg>
        );
    // variant 6 — sunflower
    return (
        <svg viewBox="0 0 200 240" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" fill="none">
                <circle cx="100" cy="80" r="14" />
                {Array.from({ length: 12 }).map((_, i) => {
                    const angle = (i * Math.PI * 2) / 12;
                    const x1 = 100 + Math.cos(angle) * 18;
                    const y1 = 80 + Math.sin(angle) * 18;
                    const x2 = 100 + Math.cos(angle) * 34;
                    const y2 = 80 + Math.sin(angle) * 34;
                    return (
                        <ellipse
                            key={i}
                            cx={(x1 + x2) / 2}
                            cy={(y1 + y2) / 2}
                            rx="8"
                            ry="4"
                            transform={`rotate(${(angle * 180) / Math.PI} ${(x1 + x2) / 2} ${(y1 + y2) / 2})`}
                        />
                    );
                })}
                <path d="M100 120 L 100 220" />
                <path d="M100 160 Q 130 165, 135 145" />
                <path d="M100 180 Q 70 185, 65 165" />
                <path d="M60 220 L 140 220" />
            </g>
        </svg>
    );
};

const GalleryMotif = ({ i }) => {
    const motifs = [1, 2, 3, 4, 5, 6, 1, 2, 3, 4, 5, 6];
    return <Bouquet variant={motifs[i % motifs.length]} />;
};

/* ---------- Divider ---------- */
const Divider = () => (
    <div className="am-divider" aria-hidden="true">
        <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" fill="none">
                <path d="M20 8 C 14 14, 14 22, 20 28 C 26 22, 26 14, 20 8 Z" />
                <circle cx="20" cy="18" r="2.5" />
                <path d="M20 28 L 20 36" />
                <path d="M14 32 L 20 34 L 26 32" strokeOpacity="0.5" />
            </g>
        </svg>
    </div>
);

/* ---------- Navbar ---------- */
const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const links = [
        { href: "#inicio", label: "Inicio" },
        { href: "#sobre", label: "Sobre Alma Mía" },
        { href: "#catalogo", label: "Catálogo" },
        { href: "#pedido", label: "Cómo Pedir" },
        { href: "#galeria", label: "Galería" },
        { href: "#testimonios", label: "Testimonios" },
        { href: "#contacto", label: "Contacto" },
    ];

    return (
        <>
            <nav
                className="am-nav"
                data-testid="site-navbar"
                style={
                    scrolled
                        ? { background: "rgba(253, 251, 247, 0.95)" }
                        : {}
                }
            >
                <div className="am-nav__inner">
                    <a
                        href="#inicio"
                        className="am-nav__brand"
                        data-testid="nav-brand-link"
                        aria-label="Alma Mía Arte Floral — Inicio"
                        onClick={() => setOpen(false)}
                    >
                        <img
                            src={LOGO_URL}
                            alt="Alma Mía"
                            className="am-logo-mark"
                        />
                        <span>
                            <span className="am-nav__brand-name">ALMA MÍA</span>
                            <span className="am-nav__brand-tag">
                                {" "}
                                Arte floral
                            </span>
                        </span>
                    </a>

                    <div className="am-nav__links">
                        {links.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                data-testid={`nav-link-${l.href.replace("#", "")}`}
                            >
                                {l.label}
                            </a>
                        ))}
                    </div>

                    <button
                        className="am-nav__toggle"
                        aria-label="Abrir menú"
                        data-testid="nav-mobile-toggle"
                        onClick={() => setOpen((v) => !v)}
                    >
                        <span
                            style={
                                open
                                    ? {
                                          transform:
                                              "translateY(6px) rotate(45deg)",
                                      }
                                    : {}
                            }
                        />
                        <span
                            style={open ? { opacity: 0 } : {}}
                        />
                        <span
                            style={
                                open
                                    ? {
                                          transform:
                                              "translateY(-6px) rotate(-45deg)",
                                      }
                                    : {}
                            }
                        />
                    </button>
                </div>
            </nav>

            <div
                className={`am-mobile-menu ${open ? "open" : ""}`}
                data-testid="nav-mobile-menu"
            >
                {links.map((l) => (
                    <a
                        key={l.href}
                        href={l.href}
                        onClick={() => setOpen(false)}
                        data-testid={`nav-mobile-link-${l.href.replace("#", "")}`}
                    >
                        {l.label}
                    </a>
                ))}
            </div>
        </>
    );
};

/* ---------- Hero ---------- */
const Hero = () => (
    <section id="inicio" className="am-hero" data-testid="hero-section">
        <div className="am-hero__petals" aria-hidden="true">
            {Array.from({ length: 8 }).map((_, i) => {
                const style = {
                    top: `${10 + ((i * 11) % 70)}%`,
                    left: `${5 + ((i * 13) % 85)}%`,
                    animationDelay: `${(i % 4) * 0.8}s`,
                    width: `${24 + (i % 3) * 10}px`,
                    height: `${24 + (i % 3) * 10}px`,
                };
                return (
                    <svg
                        key={i}
                        className="am-hero__petal"
                        style={style}
                        viewBox="0 0 40 40"
                        fill="none"
                    >
                        <g
                            stroke="currentColor"
                            strokeWidth="1.1"
                            strokeLinecap="round"
                            fill="none"
                        >
                            <path d="M20 5 C 12 14, 12 26, 20 35 C 28 26, 28 14, 20 5 Z" />
                            <circle cx="20" cy="20" r="2.5" />
                        </g>
                    </svg>
                );
            })}
        </div>

        <div className="am-hero__inner">
            <div className="am-hero__eyebrow">Boutique floral · Escárcega</div>
            <h1 className="am-hero__title" data-testid="hero-brand-title">
                ALMA MÍA
            </h1>
            <div className="am-hero__script">Arte floral</div>
            <p className="am-hero__tag" data-testid="hero-tagline">
                Lo que sientes, ¡dilo con flores!
            </p>

            <div className="am-hero__cta-row">
                <a
                    href="#catalogo"
                    className="am-btn am-btn--primary"
                    data-testid="hero-cta-catalog"
                >
                    Ver Catálogo
                    <i
                        className="fa-solid fa-arrow-right"
                        aria-hidden="true"
                    ></i>
                </a>
                <a
                    href={buildWhatsappLink(WA_GENERAL_MESSAGE)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="am-btn am-btn--ghost"
                    data-testid="hero-cta-whatsapp"
                >
                    <i
                        className="fa-brands fa-whatsapp"
                        aria-hidden="true"
                    ></i>
                    Escríbenos
                </a>
            </div>
        </div>

        <div className="am-hero__scroll" aria-hidden="true">
            <span></span>
            Descubre
        </div>
    </section>
);

/* ---------- About ---------- */
const About = () => (
    <section id="sobre" className="am-section am-about" data-testid="about-section">
        <div className="am-section__inner">
            <div className="am-about__grid">
                <div className="am-about__img-wrap" data-testid="about-image">
                    <img
                        src="/about/cynthia.jpg"
                        alt="Cynthia Talavera — Alma Mía Arte Floral"
                        className="am-about__img"
                        loading="lazy"
                    />
                </div>

                <div className="am-about__text">
                    <div className="am-eyebrow">Nuestra historia</div>
                    <h2
                        className="am-heading"
                        style={{ marginTop: "0.5rem", marginBottom: "1.5rem" }}
                    >
                        Sobre Alma Mía
                    </h2>
                    <Divider />
                    <div style={{ marginTop: "2rem" }}>
                        <p>
                            En <strong style={{ color: "var(--am-rose-dark)", fontWeight: 500 }}>Alma Mía</strong> creemos
                            que cada flor cuenta una historia. Somos un estudio
                            artesanal fundado por una floristra apasionada del
                            detalle, dedicada a crear arreglos de diseñador
                            únicos, pensados para quienes buscan expresar lo
                            que sienten con elegancia y sensibilidad.
                        </p>
                        <p>
                            Trabajamos flor por flor, seleccionando cada tallo
                            con cuidado para componer piezas que se sientan
                            vivas, poéticas e irrepetibles.{" "}
                            <em>Escuchamos</em> el momento, la ocasión y sobre
                            todo, te escuchamos a ti. Así, convertimos esa
                            emoción en un diseño que impacta.
                        </p>
                        <p>
                            Nuestros arreglos nacen en{" "}
                            <strong style={{ color: "var(--am-rose-dark)", fontWeight: 500 }}>
                                Escárcega, Campeche
                            </strong>
                            , inspirados por la calidez del sureste mexicano y
                            el deseo de hacer de cada entrega un pequeño
                            instante inolvidable.
                        </p>
                        <span className="am-about__signature">
                            — Cynthia Talavera
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

/* ---------- Catalog ---------- */
const buildPriceWaLink = (productName, price, extra = "") =>
    buildWhatsappLink(
        `Hola Alma Mía 🌸 Me interesa el siguiente diseño: ${productName}${extra ? " " + extra : ""} (${price}). ¿Me puedes dar más información y disponibilidad?`
    );

const parsePrice = (s) => {
    if (!s) return 0;
    const n = parseInt(String(s).replace(/[^0-9]/g, ""), 10);
    return isNaN(n) ? 0 : n;
};
const fmtPrice = (n) => `$${n.toLocaleString("en-US")}`;

const BADGES = {
    bestseller: { label: "★ Best Seller", cls: "am-card__media-tag--featured" },
    premium: { label: "◆ Premium", cls: "am-card__media-tag--premium" },
};

/* Product card (regular OR photoVariants with different prices) */
const ProductCard = ({ item, idPrefix, onZoom, onOrder }) => {
    const isPhotoVariant = Array.isArray(item.photoVariants) && item.photoVariants.length > 0;
    const [vIdx, setVIdx] = useState(0);

    const images = isPhotoVariant
        ? item.photoVariants.map((v) => v.image)
        : item.images;
    const currentPrice = isPhotoVariant ? item.photoVariants[vIdx].price : item.price;
    const currentLabel = isPhotoVariant ? item.photoVariants[vIdx].label : null;
    const hasMany = images && images.length > 1;
    const badge = item.badge ? BADGES[item.badge] : null;

    const waExtra = currentLabel ? `(${currentLabel})` : "";
    const zoomData = { name: item.name, images, price: currentPrice };
    const orderData = {
        name: item.name,
        price: currentPrice,
        variantLabel: currentLabel,
    };

    return (
        <article className="am-card" data-testid={`${idPrefix}-card`}>
            <div className="am-card__media">
                {badge && (
                    <span className={`am-card__media-tag ${badge.cls}`}>
                        {badge.label}
                    </span>
                )}
                <button
                    type="button"
                    className="am-card__media-btn"
                    onClick={() => onZoom(zoomData, vIdx)}
                    aria-label={`Ampliar foto de ${item.name}`}
                    data-testid={`${idPrefix}-zoom`}
                >
                    <img
                        src={`/catalog/${images[vIdx]}`}
                        alt={item.name}
                        loading="lazy"
                    />
                    <span className="am-card__zoom-hint">
                        <i className="fa-solid fa-magnifying-glass-plus"></i>
                    </span>
                </button>
                {hasMany && (
                    <div className="am-card__dots" role="tablist" aria-label="Fotos del diseño">
                        {images.map((_, i) => (
                            <button
                                key={i}
                                type="button"
                                className={`am-card__dot ${i === vIdx ? "is-active" : ""}`}
                                onClick={() => setVIdx(i)}
                                aria-label={`Ver foto ${i + 1}`}
                                data-testid={`${idPrefix}-dot-${i}`}
                            />
                        ))}
                    </div>
                )}
            </div>
            <div className="am-card__body">
                <h3 className="am-card__name">{item.name}</h3>
                <p className="am-card__desc">{item.desc}</p>
                {isPhotoVariant && (
                    <div className="am-card__variants">
                        {item.photoVariants.map((pv, i) => (
                            <button
                                key={i}
                                type="button"
                                className={`am-card__variant-btn ${i === vIdx ? "is-active" : ""}`}
                                onClick={() => setVIdx(i)}
                                data-testid={`${idPrefix}-variant-${i}`}
                                aria-pressed={i === vIdx}
                            >
                                {pv.label}
                            </button>
                        ))}
                    </div>
                )}
                <div className="am-card__price">{currentPrice}</div>
                <button
                    type="button"
                    className="am-card__cta"
                    onClick={() => onOrder(orderData)}
                    data-testid={`${idPrefix}-order`}
                    aria-label={`Pedir ${item.name}`}
                >
                    <i className="fa-brands fa-whatsapp" aria-hidden="true"></i>
                    Pedir este diseño
                </button>
            </div>
        </article>
    );
};

/* Quantity-variant card (Clásico Gerberas/Lilies, Sunflower, Lindo Día, Radiante) */
const QuantityCard = ({ item, idPrefix, onZoom, onOrder }) => {
    const [vIdx, setVIdx] = useState(0);
    const v = item.variants[vIdx];
    const zoomData = { name: item.name, images: [item.image], price: v.price };
    const orderData = {
        name: item.name,
        price: v.price,
        variantLabel: v.label,
    };

    return (
        <article className="am-card am-card--wide" data-testid={`${idPrefix}-card`}>
            <div className="am-card__media">
                <span className="am-card__media-tag">{item.name}</span>
                <button
                    type="button"
                    className="am-card__media-btn"
                    onClick={() => onZoom(zoomData, 0)}
                    aria-label={`Ampliar foto de ${item.name}`}
                    data-testid={`${idPrefix}-zoom`}
                >
                    <img src={`/catalog/${item.image}`} alt={item.name} loading="lazy" />
                    <span className="am-card__zoom-hint">
                        <i className="fa-solid fa-magnifying-glass-plus"></i>
                    </span>
                </button>
            </div>
            <div className="am-card__body">
                <h3 className="am-card__name">{item.name}</h3>
                <p className="am-card__desc">{item.desc}</p>
                <div className="am-clasico__qty-label">{item.qtyLabel || "Cantidad"}</div>
                <div className="am-clasico__qty am-clasico__qty--wrap" role="tablist">
                    {item.variants.map((cv, i) => (
                        <button
                            key={cv.label}
                            type="button"
                            className={`am-clasico__qty-btn ${i === vIdx ? "is-active" : ""}`}
                            onClick={() => setVIdx(i)}
                            data-testid={`${idPrefix}-qty-${i}`}
                            role="tab"
                            aria-selected={i === vIdx}
                        >
                            {cv.label}
                        </button>
                    ))}
                </div>
                <div className="am-card__price" data-testid={`${idPrefix}-price`}>
                    {v.price}
                </div>
                <button
                    type="button"
                    className="am-card__cta"
                    onClick={() => onOrder(orderData)}
                    data-testid={`${idPrefix}-order`}
                >
                    <i className="fa-brands fa-whatsapp"></i>
                    Pedir {item.name}
                </button>
            </div>
        </article>
    );
};

/* ---------- Complementos Panel ---------- */
const ComplementosPanel = ({ onZoom }) => {
    const [sel, setSel] = useState(0);
    const c = COMPLEMENTOS[sel];
    const zoomData = {
        name: `Complemento — ${c.name}`,
        images: ["complementos.jpg"],
        price: c.price,
    };
    return (
        <div className="am-complementos" data-testid="complementos-panel">
            <div className="am-complementos__list">
                <div className="am-complementos__list-title">
                    <span className="am-eyebrow" style={{ fontSize: "1rem" }}>
                        Personaliza tu arreglo
                    </span>
                    <h4 className="am-card__name" style={{ marginTop: "0.4rem" }}>
                        Complementos
                    </h4>
                    <p className="am-card__desc" style={{ marginBottom: "1.25rem" }}>
                        Toca un complemento para verlo destacado en la foto.
                    </p>
                </div>
                {COMPLEMENTOS.map((cp, i) => (
                    <button
                        key={cp.name}
                        type="button"
                        className={`am-complementos__item ${i === sel ? "is-active" : ""}`}
                        onClick={() => setSel(i)}
                        data-testid={`complemento-item-${cp.name.toLowerCase().replace(/\s+/g, "-")}`}
                        aria-pressed={i === sel}
                    >
                        <span className="am-complementos__item-name">{cp.name}</span>
                        <span className="am-complementos__item-meta">
                            <span className="am-complementos__item-desc">{cp.desc}</span>
                            <span className="am-complementos__item-price">{cp.price}</span>
                        </span>
                    </button>
                ))}
                <a
                    className="am-btn am-btn--primary"
                    style={{ marginTop: "1.25rem", alignSelf: "flex-start" }}
                    href={buildPriceWaLink(`Complemento — ${c.name}`, c.price)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="complemento-wa"
                >
                    <i className="fa-brands fa-whatsapp"></i>
                    Agregar {c.name}
                </a>
            </div>

            <button
                type="button"
                className="am-complementos__photo"
                onClick={() => onZoom(zoomData, 0)}
                aria-label={`Ampliar foto del complemento ${c.name}`}
                data-testid="complementos-photo"
                style={{ "--spot-x": `${c.spot.x}%`, "--spot-y": `${c.spot.y}%` }}
            >
                <img src="/catalog/complementos.jpg" alt="Complementos decorativos" loading="lazy" />
                <div className="am-complementos__overlay" aria-hidden="true" />
                <div
                    className="am-complementos__pin"
                    style={{ left: `${c.spot.x}%`, top: `${c.spot.y}%` }}
                    aria-hidden="true"
                >
                    <span>{c.name}</span>
                </div>
            </button>
        </div>
    );
};

/* Sub-section wrapper */
const SubSection = ({ title, children, count }) => (
    <div className="am-catalog__subsection">
        <h3 className="am-catalog__subsection-title">
            <span>
                {title}
                {typeof count === "number" && (
                    <em className="am-catalog__subsection-count">{count}</em>
                )}
            </span>
        </h3>
        {children}
    </div>
);

/* Grid of ProductCards */
const ProductGrid = ({ items, prefix, onZoom, onOrder, testId }) => (
    <div className="am-catalog__grid" data-testid={testId}>
        {items.map((p, i) => (
            <ProductCard
                key={p.name}
                item={p}
                idPrefix={`${prefix}-${i}`}
                onZoom={onZoom}
                onOrder={onOrder}
            />
        ))}
    </div>
);

/* ---------- Order Modal (asks for complementos before WhatsApp) ---------- */
const OrderModal = ({ product, onClose }) => {
    const [selected, setSelected] = useState({});
    const basePrice = parsePrice(product.price);
    const selectedItems = COMPLEMENTOS.filter((c) => selected[c.name]);
    const complementsSum = selectedItems.reduce(
        (acc, c) => acc + parsePrice(c.price),
        0
    );
    const total = basePrice + complementsSum;

    useEffect(() => {
        const onKey = (e) => {
            if (e.key === "Escape") onClose();
        };
        window.addEventListener("keydown", onKey);
        document.body.classList.add("am-lock");
        return () => {
            window.removeEventListener("keydown", onKey);
            document.body.classList.remove("am-lock");
        };
    }, [onClose]);

    const toggle = (name) =>
        setSelected((s) => ({ ...s, [name]: !s[name] }));

    const buildMessage = (skipComplementos = false) => {
        const variantSuffix = product.variantLabel
            ? ` (${product.variantLabel})`
            : "";
        let msg = `Hola Alma Mía 🌸 Me interesa el siguiente diseño:\n• ${product.name}${variantSuffix} — ${product.price}`;
        if (!skipComplementos && selectedItems.length > 0) {
            msg += `\n\nComplementos:`;
            selectedItems.forEach((c) => {
                msg += `\n• ${c.name} — ${c.price}`;
            });
            msg += `\n\nTotal aproximado: ${fmtPrice(total)}`;
        }
        msg += `\n\n¿Me puedes dar más información y disponibilidad?`;
        return msg;
    };

    const sendToWhatsApp = (skipComplementos = false) => {
        const url = buildWhatsappLink(buildMessage(skipComplementos));
        window.open(url, "_blank", "noopener,noreferrer");
        onClose();
    };

    return (
        <div
            className="am-modal-overlay"
            onClick={onClose}
            role="dialog"
            aria-modal="true"
            aria-labelledby="order-modal-title"
            data-testid="order-modal"
        >
            <div
                className="am-modal"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    type="button"
                    className="am-modal__close"
                    onClick={onClose}
                    aria-label="Cerrar"
                    data-testid="order-modal-close"
                >
                    <i className="fa-solid fa-xmark"></i>
                </button>

                <div className="am-modal__header">
                    <div className="am-eyebrow" style={{ fontSize: "0.95rem" }}>
                        Tu pedido
                    </div>
                    <h3 id="order-modal-title" className="am-modal__title">
                        ¿Deseas añadir complementos?
                    </h3>
                    <p className="am-modal__subtitle">
                        Personaliza tu <strong>{product.name}</strong>
                        {product.variantLabel ? ` (${product.variantLabel})` : ""}
                        {" — "}
                        <span className="am-modal__baseprice">{product.price}</span>
                    </p>
                </div>

                <div className="am-modal__list" data-testid="order-modal-complementos">
                    {COMPLEMENTOS.map((c) => {
                        const isOn = !!selected[c.name];
                        return (
                            <button
                                type="button"
                                key={c.name}
                                className={`am-modal__item ${isOn ? "is-active" : ""}`}
                                onClick={() => toggle(c.name)}
                                data-testid={`order-comp-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
                                aria-pressed={isOn}
                            >
                                <span className="am-modal__check">
                                    <i
                                        className={
                                            isOn
                                                ? "fa-solid fa-circle-check"
                                                : "fa-regular fa-circle"
                                        }
                                    ></i>
                                </span>
                                <span className="am-modal__item-name">{c.name}</span>
                                <span className="am-modal__item-desc">{c.desc}</span>
                                <span className="am-modal__item-price">{c.price}</span>
                            </button>
                        );
                    })}
                </div>

                <div className="am-modal__footer">
                    <div className="am-modal__total" data-testid="order-modal-total">
                        <span className="am-modal__total-label">Total aproximado</span>
                        <span className="am-modal__total-value">{fmtPrice(total)}</span>
                    </div>
                    <div className="am-modal__actions">
                        <button
                            type="button"
                            className="am-btn am-btn--ghost"
                            onClick={() => sendToWhatsApp(true)}
                            data-testid="order-skip-complementos"
                        >
                            Sin complementos
                        </button>
                        <button
                            type="button"
                            className="am-btn am-btn--whatsapp"
                            onClick={() => sendToWhatsApp(false)}
                            data-testid="order-send-wa"
                        >
                            <i className="fa-brands fa-whatsapp"></i>
                            Enviar por WhatsApp
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ---------- Catalog Section ---------- */
const Catalog = ({ onZoom, onOrder }) => {
    const [activeCat, setActiveCat] = useState("Gerberas");

    return (
        <section
            id="catalogo"
            className="am-section am-catalog"
            data-testid="catalog-section"
        >
            <div className="am-section__inner">
                <div className="am-catalog__intro">
                    <div className="am-eyebrow">Nuestra selección</div>
                    <h2
                        className="am-heading"
                        style={{ marginTop: "0.5rem", marginBottom: "1rem" }}
                    >
                        Catálogo de Diseños
                    </h2>
                    <Divider />
                    <p>
                        Cada diseño puede personalizarse a tu tono, paleta y
                        ocasión — <em>sólo escríbenos</em>.
                    </p>
                </div>

                <div
                    className="am-catalog__tabs"
                    role="tablist"
                    aria-label="Categorías de catálogo"
                    data-testid="catalog-tabs"
                >
                    {CATEGORIES.map((cat) => (
                        <button
                            key={cat.id}
                            type="button"
                            role="tab"
                            aria-selected={activeCat === cat.id}
                            className={`am-catalog__tab ${activeCat === cat.id ? "is-active" : ""}`}
                            onClick={() => setActiveCat(cat.id)}
                            data-testid={`catalog-tab-${cat.id.toLowerCase()}`}
                        >
                            {cat.label}
                        </button>
                    ))}
                </div>

                {activeCat === "Gerberas" && (
                    <div data-testid="catalog-content-gerberas">
                        <SubSection title="Gerberas" count={GERBERAS.Gerberas.length}>
                            <ProductGrid
                                items={GERBERAS.Gerberas}
                                prefix="ger"
                                onZoom={onZoom}
                                onOrder={onOrder}
                                
                                testId="catalog-grid-gerberas"
                            />
                        </SubSection>
                        <SubSection title="Clásico">
                            <div className="am-catalog__grid am-catalog__grid--single">
                                <QuantityCard
                                    item={GERBERAS.ClasicoGerberas}
                                    idPrefix="clasico-ger"
                                    onZoom={onZoom}
                                    onOrder={onOrder}
                                />
                            </div>
                        </SubSection>
                        <SubSection title="Premium" count={GERBERAS.Premium.length}>
                            <ProductGrid
                                items={GERBERAS.Premium}
                                prefix="pre"
                                onZoom={onZoom}
                                onOrder={onOrder}
                                
                                testId="catalog-grid-premium"
                            />
                        </SubSection>
                    </div>
                )}

                {activeCat === "Rosas" && (
                    <div data-testid="catalog-content-rosas">
                        {Object.entries(ROSAS).map(([groupName, items]) => (
                            <SubSection
                                key={groupName}
                                title={groupName}
                                count={items.length}
                            >
                                <ProductGrid
                                    items={items}
                                    prefix={`ros-${groupName.replace(/\s+/g, "").toLowerCase()}`}
                                    onZoom={onZoom}
                                    testId={`catalog-grid-rosas-${groupName.replace(/[^0-9]/g, "")}`}
                                />
                            </SubSection>
                        ))}
                    </div>
                )}

                {activeCat === "Girasoles" && (
                    <div data-testid="catalog-content-girasoles">
                        <SubSection title="Diseños" count={GIRASOLES.Disenos.length}>
                            <ProductGrid
                                items={GIRASOLES.Disenos}
                                prefix="gir"
                                onZoom={onZoom}
                                onOrder={onOrder}
                                
                                testId="catalog-grid-girasoles"
                            />
                        </SubSection>
                        <SubSection title="Sunflower">
                            <div className="am-catalog__grid am-catalog__grid--single">
                                <QuantityCard
                                    item={GIRASOLES.Sunflower}
                                    idPrefix="sunflower"
                                    onZoom={onZoom}
                                    onOrder={onOrder}
                                />
                            </div>
                        </SubSection>
                        <SubSection title="Lindo Día">
                            <div className="am-catalog__grid am-catalog__grid--single">
                                <QuantityCard
                                    item={GIRASOLES.LindoDia}
                                    idPrefix="lindodia"
                                    onZoom={onZoom}
                                    onOrder={onOrder}
                                />
                            </div>
                        </SubSection>
                        <SubSection title="Radiante">
                            <div className="am-catalog__grid am-catalog__grid--single">
                                <QuantityCard
                                    item={GIRASOLES.Radiante}
                                    idPrefix="radiante"
                                    onZoom={onZoom}
                                    onOrder={onOrder}
                                />
                            </div>
                        </SubSection>
                    </div>
                )}

                {activeCat === "Lilies" && (
                    <div data-testid="catalog-content-lilies">
                        <SubSection title="Clásico">
                            <div className="am-catalog__grid am-catalog__grid--single">
                                <QuantityCard
                                    item={LILIES.ClasicoLilies}
                                    idPrefix="clasico-lil"
                                    onZoom={onZoom}
                                    onOrder={onOrder}
                                />
                            </div>
                        </SubSection>
                        <SubSection title="Diseños" count={LILIES.Disenos.length}>
                            <ProductGrid
                                items={LILIES.Disenos}
                                prefix="lil"
                                onZoom={onZoom}
                                onOrder={onOrder}
                                
                                testId="catalog-grid-lilies"
                            />
                        </SubSection>
                    </div>
                )}

                {/* Complementos — always visible below the active category */}
                <SubSection title="Complementos">
                    <ComplementosPanel onZoom={onZoom} />
                </SubSection>
            </div>
        </section>
    );
};


/* ---------- Steps ---------- */
const STEPS = [
    {
        icon: "fa-regular fa-heart",
        title: "Elige tu diseño",
        desc: "Encuentra tu favorito dentro del catálogo o cuéntanos tu idea.",
    },
    {
        icon: "fa-brands fa-whatsapp",
        title: "Escríbenos por WhatsApp",
        desc: "Confirmamos detalles, paleta, fecha y lugar de entrega.",
    },
    {
        icon: "fa-regular fa-calendar",
        title: "Coordinamos entrega",
        desc: "Entrega a domicilio en Escárcega o recolección en estudio.",
    },
    {
        icon: "fa-regular fa-envelope-open",
        title: "Recíbelo con amor",
        desc: "Un arreglo hecho a mano, listo para conmover.",
    },
];

const Steps = () => (
    <section
        id="pedido"
        className="am-section am-steps"
        data-testid="steps-section"
    >
        <div className="am-section__inner">
            <div style={{ textAlign: "center" }}>
                <div className="am-eyebrow">Así de fácil</div>
                <h2
                    className="am-heading"
                    style={{ marginTop: "0.5rem", marginBottom: "1rem" }}
                >
                    Cómo hacer un pedido
                </h2>
                <Divider />
            </div>

            <div className="am-steps__grid">
                {STEPS.map((s, i) => (
                    <div
                        className="am-step"
                        key={s.title}
                        data-testid={`step-${i + 1}`}
                    >
                        <div className="am-step__circle">
                            <i
                                className={s.icon}
                                style={{ fontSize: "1.8rem" }}
                                aria-hidden="true"
                            ></i>
                            <span className="am-step__num">{i + 1}</span>
                        </div>
                        <h3 className="am-step__title">{s.title}</h3>
                        <p className="am-step__desc">{s.desc}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

/* ---------- Gallery ---------- */
const GALLERY_ITEMS = [
    { title: "Diseño Alma Mía · 01", image: "/gallery/alma_01.jpg" },
    { title: "Diseño Alma Mía · 02", image: "/gallery/alma_02.jpg" },
    { title: "Diseño Alma Mía · 03", image: "/gallery/alma_03.jpg" },
    { title: "Diseño Alma Mía · 04", image: "/gallery/alma_04.jpg" },
    { title: "Diseño Alma Mía · 05", image: "/gallery/alma_05.jpg" },
    { title: "Diseño Alma Mía · 06", image: "/gallery/alma_06.jpg" },
    { title: "Diseño Alma Mía · 07", image: "/gallery/alma_07.jpg" },
    { title: "Diseño Alma Mía · 08", image: "/gallery/alma_08.jpg" },
];

const Gallery = ({ onOpen }) => (
    <section
        id="galeria"
        className="am-section am-gallery"
        data-testid="gallery-section"
    >
        <div className="am-section__inner">
            <div style={{ textAlign: "center" }}>
                <div className="am-eyebrow">Nuestro portafolio</div>
                <h2
                    className="am-heading"
                    style={{ marginTop: "0.5rem", marginBottom: "1rem" }}
                >
                    Trabajos Realizados
                </h2>
                <Divider />
            </div>

            <div className="am-gallery__grid" data-testid="gallery-grid">
                {GALLERY_ITEMS.map((item, i) => (
                    <button
                        type="button"
                        className="am-gallery__tile"
                        key={i}
                        data-testid={`gallery-tile-${i}`}
                        aria-label={`Abrir ${item.title} en vista ampliada`}
                        onClick={() =>
                            onOpen({
                                images: [item.image],
                                title: item.title,
                                meta: "",
                            })
                        }
                    >
                        <img
                            src={item.image}
                            alt={item.title}
                            className="am-gallery__tile-img"
                            loading="lazy"
                        />
                        <div className="am-gallery__tile-hint" aria-hidden="true">
                            <span>
                                <i className="fa-solid fa-magnifying-glass-plus"></i>
                            </span>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    </section>
);

/* ---------- Lightbox (unificado: galería + productos) ---------- */
const Lightbox = ({ data, onClose }) => {
    const [idx, setIdx] = useState(data.index || 0);
    const total = data.images && data.images.length ? data.images.length : 1;

    useEffect(() => {
        const onKey = (e) => {
            if (e.key === "Escape") onClose();
            if (e.key === "ArrowLeft") setIdx((i) => (i - 1 + total) % total);
            if (e.key === "ArrowRight") setIdx((i) => (i + 1) % total);
        };
        window.addEventListener("keydown", onKey);
        document.body.classList.add("am-lock");
        return () => {
            window.removeEventListener("keydown", onKey);
            document.body.classList.remove("am-lock");
        };
    }, [onClose, total]);

    const prev = () => setIdx((i) => (i - 1 + total) % total);
    const next = () => setIdx((i) => (i + 1) % total);
    const hasMany = total > 1;
    const currentSrc =
        data.images && data.images.length ? data.images[idx] : null;

    return (
        <div
            className="am-lightbox"
            onClick={onClose}
            role="dialog"
            aria-modal="true"
            aria-label={`Vista ampliada: ${data.title}`}
            data-testid="lightbox-overlay"
        >
            {hasMany && (
                <div
                    className="am-lightbox__counter"
                    data-testid="lightbox-counter"
                >
                    {idx + 1} / {total}
                </div>
            )}

            <button
                type="button"
                className="am-lightbox__close"
                aria-label="Cerrar"
                data-testid="lightbox-close"
                onClick={(e) => {
                    e.stopPropagation();
                    onClose();
                }}
            >
                <i className="fa-solid fa-xmark"></i>
            </button>

            {hasMany && (
                <button
                    type="button"
                    className="am-lightbox__arrow am-lightbox__arrow--prev"
                    aria-label="Anterior"
                    data-testid="lightbox-prev"
                    onClick={(e) => {
                        e.stopPropagation();
                        prev();
                    }}
                >
                    <i className="fa-solid fa-chevron-left"></i>
                </button>
            )}

            <div
                className={`am-lightbox__stage ${currentSrc ? "am-lightbox__stage--photo" : ""}`}
                onClick={(e) => e.stopPropagation()}
                key={idx}
                data-testid="lightbox-stage"
            >
                {currentSrc ? (
                    <img
                        src={currentSrc}
                        alt={data.title}
                        className="am-lightbox__img"
                    />
                ) : (
                    <div className="am-lightbox__art">
                        <Bouquet variant={data.fallbackVariant || 1} />
                    </div>
                )}
                <div className="am-lightbox__caption">
                    <h3 className="am-lightbox__caption-title">
                        {data.title}
                    </h3>
                    {data.meta && (
                        <div className="am-lightbox__caption-meta">
                            {data.meta}
                        </div>
                    )}
                </div>
            </div>

            {hasMany && (
                <button
                    type="button"
                    className="am-lightbox__arrow am-lightbox__arrow--next"
                    aria-label="Siguiente"
                    data-testid="lightbox-next"
                    onClick={(e) => {
                        e.stopPropagation();
                        next();
                    }}
                >
                    <i className="fa-solid fa-chevron-right"></i>
                </button>
            )}
        </div>
    );
};


/* ---------- Testimonials ---------- */
const TESTIMONIALS = [
    {
        text: "Recibí mi ramo y me emocioné hasta las lágrimas. Cada flor estaba puesta con un cariño que se nota. Gracias, Alma Mía, fue magia pura.",
        name: "María Fernanda R.",
        role: "Boda íntima · 2024",
    },
    {
        text: "Pedí un arreglo en caja para mi mamá y superó cualquier expectativa. Colores suaves, fragancia deliciosa y presentación impecable.",
        name: "Ana Sofía T.",
        role: "Día de las Madres",
    },
    {
        text: "Son verdaderas artistas. El bouquet silvestre que me hicieron parecía salido de un cuento. Definitivamente mi floristería de cabecera.",
        name: "Regina Méndez",
        role: "Aniversario",
    },
];

const Testimonials = () => (
    <section
        id="testimonios"
        className="am-section am-testimonials"
        data-testid="testimonials-section"
    >
        <div className="am-section__inner">
            <div style={{ textAlign: "center" }}>
                <div className="am-eyebrow">Con el corazón</div>
                <h2
                    className="am-heading"
                    style={{ marginTop: "0.5rem", marginBottom: "1rem" }}
                >
                    Testimonios
                </h2>
                <Divider />
            </div>

            <div className="am-testimonials__grid">
                {TESTIMONIALS.map((t, i) => (
                    <div
                        className="am-testimonial"
                        key={t.name}
                        data-testid={`testimonial-${i}`}
                    >
                        <div className="am-testimonial__quote">“</div>
                        <div
                            className="am-testimonial__stars"
                            aria-label="5 estrellas"
                        >
                            ★ ★ ★ ★ ★
                        </div>
                        <p className="am-testimonial__text">{t.text}</p>
                        <div className="am-testimonial__name">{t.name}</div>
                        <div className="am-testimonial__role">{t.role}</div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

/* ---------- Contact ---------- */
const Contact = () => (
    <section
        id="contacto"
        className="am-section am-contact"
        data-testid="contact-section"
    >
        <div className="am-section__inner">
            <div style={{ textAlign: "center" }}>
                <div className="am-eyebrow">Hablemos</div>
                <h2
                    className="am-heading"
                    style={{ marginTop: "0.5rem", marginBottom: "1rem" }}
                >
                    Contacto & Ubicación
                </h2>
                <Divider />
            </div>

            <div className="am-contact__grid">
                <div className="am-contact__info">
                    <div className="am-contact__row">
                        <div className="am-contact__icon">
                            <i
                                className="fa-solid fa-location-dot"
                                aria-hidden="true"
                            ></i>
                        </div>
                        <div>
                            <div className="am-contact__label">Ubicación</div>
                            <p
                                className="am-contact__value"
                                style={{ lineHeight: 1.55 }}
                            >
                                Calle 28 entre 31 y 33, Colonia Morelos
                                <br />
                                Enfrente de la cancha municipal
                                <br />
                                Escárcega de Matamoros, Campeche, México
                            </p>
                        </div>
                    </div>

                    <div className="am-contact__row">
                        <div className="am-contact__icon">
                            <i
                                className="fa-solid fa-phone"
                                aria-hidden="true"
                            ></i>
                        </div>
                        <div>
                            <div className="am-contact__label">Teléfono · WhatsApp</div>
                            <a
                                href={buildWhatsappLink(WA_GENERAL_MESSAGE)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="am-contact__value"
                                data-testid="contact-phone"
                            >
                                +52 982 115 6234
                            </a>
                        </div>
                    </div>

                    <div className="am-contact__row">
                        <div className="am-contact__icon">
                            <i
                                className="fa-solid fa-envelope"
                                aria-hidden="true"
                            ></i>
                        </div>
                        <div>
                            <div className="am-contact__label">Correo</div>
                            <a
                                href="mailto:cym18@hotmail.es"
                                className="am-contact__value"
                                data-testid="contact-email"
                            >
                                cym18@hotmail.es
                            </a>
                        </div>
                    </div>

                    <div className="am-contact__row">
                        <div className="am-contact__icon">
                            <i
                                className="fa-solid fa-heart"
                                aria-hidden="true"
                            ></i>
                        </div>
                        <div>
                            <div className="am-contact__label">Redes sociales</div>
                            <div className="am-contact__socials">
                                <a
                                    href="https://www.instagram.com/almamia.artefloral/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="am-contact__social"
                                    aria-label="Instagram @almamia.artefloral"
                                    data-testid="contact-instagram"
                                >
                                    <i
                                        className="fa-brands fa-instagram"
                                        aria-hidden="true"
                                    ></i>
                                </a>
                                <a
                                    href="https://www.facebook.com/Almamiabycynthiatalavera"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="am-contact__social"
                                    aria-label="Facebook Almamiabycynthiatalavera"
                                    data-testid="contact-facebook"
                                >
                                    <i
                                        className="fa-brands fa-facebook-f"
                                        aria-hidden="true"
                                    ></i>
                                </a>
                                <a
                                    href="https://www.tiktok.com/@almamiaartefloral"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="am-contact__social"
                                    aria-label="TikTok @almamiaartefloral"
                                    data-testid="contact-tiktok"
                                >
                                    <i
                                        className="fa-brands fa-tiktok"
                                        aria-hidden="true"
                                    ></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="am-contact__map"
                    data-testid="contact-map"
                >
                    <iframe
                        title="Mapa — Escárcega, Campeche"
                        src="https://www.google.com/maps?q=Calle+28+entre+31+y+33%2C+Colonia+Morelos%2C+Esc%C3%A1rcega+de+Matamoros%2C+Campeche%2C+M%C3%A9xico&output=embed"
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        allowFullScreen
                    />
                </div>
            </div>
        </div>
    </section>
);

/* ---------- Footer ---------- */
const Footer = () => (
    <footer className="am-footer" data-testid="site-footer">
        <div className="am-footer__inner">
            <div>
                <h3 className="am-footer__brand-name">ALMA MÍA</h3>
                <p className="am-footer__brand-tag">Arte floral</p>
                <p className="am-footer__text">
                    Diseños artesanales hechos con amor en Escárcega, Campeche.
                    Lo que sientes, dilo con flores.
                </p>
            </div>

            <div className="am-footer__col">
                <h4>Navegación</h4>
                <a href="#inicio">Inicio</a>
                <a href="#sobre">Sobre Alma Mía</a>
                <a href="#catalogo">Catálogo</a>
                <a href="#pedido">Cómo Pedir</a>
                <a href="#galeria">Galería</a>
                <a href="#testimonios">Testimonios</a>
                <a href="#contacto">Contacto</a>
            </div>

            <div className="am-footer__col">
                <h4>Contacto</h4>
                <a href={buildWhatsappLink(WA_GENERAL_MESSAGE)} target="_blank" rel="noopener noreferrer">
                    +52 982 115 6234
                </a>
                <a href="mailto:cym18@hotmail.es">cym18@hotmail.es</a>
                <a href="#contacto">Escárcega, Campeche · MX</a>

                <div className="am-footer__socials" style={{ marginTop: "1rem" }}>
                    <a
                        href="https://www.instagram.com/almamia.artefloral/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                    >
                        <i className="fa-brands fa-instagram"></i>
                    </a>
                    <a
                        href="https://www.facebook.com/Almamiabycynthiatalavera"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Facebook"
                    >
                        <i className="fa-brands fa-facebook-f"></i>
                    </a>
                    <a
                        href="https://www.tiktok.com/@almamiaartefloral"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="TikTok"
                    >
                        <i className="fa-brands fa-tiktok"></i>
                    </a>
                </div>
            </div>
        </div>
        <div className="am-footer__bottom">
            © 2025 Alma Mía Arte Floral. Todos los derechos reservados.
        </div>
    </footer>
);

/* ---------- Floating WhatsApp ---------- */
const FloatingWhatsApp = () => (
    <a
        href={buildWhatsappLink(WA_GENERAL_MESSAGE)}
        target="_blank"
        rel="noopener noreferrer"
        className="am-wa-float"
        aria-label="Escríbenos por WhatsApp"
        data-testid="whatsapp-float-btn"
    >
        <i className="fa-brands fa-whatsapp"></i>
    </a>
);

/* ---------- App ---------- */
function App() {
    const [lightbox, setLightbox] = useState(null);
    const [orderProduct, setOrderProduct] = useState(null);

    useEffect(() => {
        document.title = "Alma Mía · Arte Floral — Escárcega, Campeche";
    }, []);

    const openLightbox = (data) => setLightbox(data);
    const closeLightbox = () => setLightbox(null);
    const openOrder = (data) => setOrderProduct(data);
    const closeOrder = () => setOrderProduct(null);

    // Catalog products → lightbox
    const onCatalogZoom = (item, startIdx = 0) => {
        const images =
            item.images && item.images.length
                ? item.images.map((f) => `/catalog/${f}`)
                : [];
        openLightbox({
            images,
            title: item.name,
            meta: item.price || item.desc || "",
            index: startIdx,
        });
    };

    return (
        <div className="App" data-testid="alma-mia-app">
            <Navbar />
            <main>
                <Hero />
                <About />
                <Catalog onZoom={onCatalogZoom} onOrder={openOrder} />
                <Steps />
                <Gallery onOpen={openLightbox} />
                <Testimonials />
                <Contact />
            </main>
            <Footer />
            <FloatingWhatsApp />
            {lightbox && <Lightbox data={lightbox} onClose={closeLightbox} />}
            {orderProduct && (
                <OrderModal product={orderProduct} onClose={closeOrder} />
            )}
        </div>
    );
}

export default App;
